import defaultThemes from './default'

export default {
  ...defaultThemes,
};
